<ng-template
  #menuDisplayTemplate
  let-selected
>
  @if (!!selected) {
    <span>{{ displayWith(selected) }}</span>
  }
  @if (!selected) {
    <span [attr.color]="disabled ? 'grey-medium' : 'grey-dark'">
      {{ placeholder }}
    </span>
  }
</ng-template>

<ng-template
  #itemDisplayTemplate
  let-option
>
  <span class="value">{{ displayWith(option) }}</span>
</ng-template>

<ng-template
  #menuButtonTemplate
  let-selected
>
  <button
    type="button"
    payee-button
    class="dropdown-button"
    [width]="width()"
    [height]="height()"
    [color]="color"
    [isBorderButton]="isBorderButton"
    [isRoundButton]="isRoundButton"
    [disabled]="disabled"
  >
    <ng-container
      [ngTemplateOutlet]="menuDisplayTemplateRef || menuDisplayTemplate"
      [ngTemplateOutletContext]="{ $implicit: selected }"
    ></ng-container>
  </button>
  <svg
    payee-suffix
    class="dropdown-arrow"
    width="25"
    height="25"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 10L12 14L17 10"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</ng-template>

<ng-content select="[payee-label]"></ng-content>
<div
  #inputWrapper
  class="payee-input-wrapper"
  [class.error]="error"
  [attr.width]="width()"
  [attr.height]="height()"
>
  <div
    class="dropdown-wrapper"
    [matMenuTriggerFor]="menu"
    [class.menu-disabled]="disabled"
    (menuClosed)="dropdownOpen.set(false)"
    (menuOpened)="onMenuOpened()"
  >
    <ng-container
      [ngTemplateOutlet]="menuButtonTemplateRef || menuButtonTemplate"
      [ngTemplateOutletContext]="{ $implicit: selected }"
    ></ng-container>
  </div>

  <mat-menu
    #menu
    xPosition="after"
    class="payee-dropdown-menu-panel"
  >
    <div
      class="options-content"
      [attr.width]="width()"
    >
      @if (filterable) {
        <div
          class="dropdown-filter-wrapper"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
        >
          <input
            class="dropdown-filter-input"
            type="text"
            [placeholder]="'DROPDOWN.FILTER_PLACEHOLDER' | translate"
            [(ngModel)]="filterText"
          />
        </div>
      }
      @for (option of filteredOptions; track $index) {
        <button
          mat-menu-item
          [style.min-width]="inputWrapper.clientWidth"
          (click)="selectOption(option)"
        >
          <ng-container
            [ngTemplateOutlet]="itemDisplayTemplateRef || itemDisplayTemplate"
            [ngTemplateOutletContext]="{ $implicit: option }"
          ></ng-container>
        </button>
      }
    </div>
  </mat-menu>
</div>
<div
  #errorsBox
  class="errors-box"
  [class.error]="error"
>
  <ng-content select="[payee-error]"></ng-content>
</div>
